import React, { useState, useEffect } from "react";
import Aside from "../../../components/Aside";
import Api from "../../../services/api";
import swal from "sweetalert";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Link, useParams } from "react-router-dom";
import NewFoto from "./new";
import EditFoto from "./edit";
import ReactTooltip from "react-tooltip";

export default function AcomodacoesFotos() {
  const { acomodacao } = useParams();
  const [loading, setLoading] = useState(true);
  const Loader = () => <div className="loading"></div>;
  const [infosAcomodacao, setInfosAcomodacao] = useState([]);
  const [fotos, setFotos] = useState([]);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [fotoEdit, setFotoEdit] = useState([]);

  useEffect(() => {
    loadInfoAcomodacao();
    loadFotosAcomodacao();
  }, []);

  function loadInfoAcomodacao() {
    Api.get("/acomodacao/" + acomodacao)
      .then((response) => {
        setInfosAcomodacao(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function loadFotosAcomodacao() {
    Api.get("/acomodacoes/fotos/" + acomodacao)
      .then((response) => {
        setFotos(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function editFoto(foto) {
    setFotoEdit(foto);
    setOpenModalEdit(true);
  }

  function alteraAtivado(foto_id, ativado) {
    setLoading(true);
    Api.post(`/acomodacoes/fotos/ativado/${foto_id}/${ativado}`)
      .then((response) => {
        loadFotosAcomodacao();
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function deleteFoto(foto) {
    swal({
      title: "Excluir foto",
      text: "Deseja realmente excluir a foto selecionada ?",
      icon: "warning",
      html: true,
      buttons: ["Cancelar", "Excluir"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        Api.delete("/acomodacoes/fotos/delete/" + foto.id)
          .then((response) => {
            swal(response.data.message, {
              icon: "success",
            });
            loadFotosAcomodacao();
            setLoading(false);
          })
          .catch((err) => {
            swal("ops! ocorreu um erro" + err, {
              icon: "success",
            });
            setLoading(false);
          });
      }
    });
  }

  function renderTopPage() {
    return (
      <div className="top">
        <div>
          <span className="text">
            Fotos da Acomodação / {infosAcomodacao[0].nome_pt}
          </span>
          <ul className="breadcrumbs">
            <li>Fotos da Acomodação / {infosAcomodacao[0].nome_pt}</li>
            <li>Fotos</li>
          </ul>
        </div>
        <div>
          <div className="actions top">
            <Link
              to="#"
              onClick={() => {
                setOpenModalNew(true);
              }}
            >
              <i className="bx bx-plus-circle"></i> Foto
            </Link>
            <Link
              to={`/acomodacoes/${acomodacao}/order`}
              onClick={() => {
                setOpenModalNew(true);
              }}
            >
              <i className="bx bx-plus-circle"></i> Ordenação
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    const rows = fotos.map((foto, index) => {
      const imagem = () => {
        return (
          foto.imagem && (
            <img src={process.env.REACT_APP_FILES_URL + foto.imagem_thumb_1} />
          )
        );
      };

      const ativado = () => {
        return foto.ativado === 1 ? (
          <a
            href="#"
            className="ativado"
            onClick={() => {
              alteraAtivado(foto.id, 0);
            }}
            data-tip="Clique para desativar"
          ></a>
        ) : (
          <a
            href="#"
            className="desativado"
            onClick={() => {
              alteraAtivado(foto.id, 1);
            }}
            data-tip="Clique para ativar"
          ></a>
        );
      };

      return (
        <div className="item" key={index}>
          <div>
            <a
              href="#"
              onClick={() => {
                editFoto(foto);
              }}
              alt="Editar"
              data-tip="Editar"
            >
              <i className="bx bx-edit"></i>
            </a>
            <a
              href="#"
              onClick={() => {
                deleteFoto(foto);
              }}
              data-tip="Excluir"
            >
              <i className="bx bx-trash"></i>
            </a>
            {ativado()}
          </div>
          <div>{imagem()}</div>
          <div>{foto.legenda}</div>
        </div>
      );
    });

    return (
      <>
        <div className="grid fotos">
          <div className="content">{rows}</div>
        </div>
      </>
    );
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container-box">
        <Aside />
        <main>
          {infosAcomodacao[0] && renderTopPage()}
          {fotos && RenderContent()}
        </main>
      </div>
      <ReactTooltip effect="solid" />
      <Modal
        open={openModalNew}
        onClose={() => {
          setOpenModalNew(false);
        }}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
      >
        <NewFoto
          acomodacaoId={acomodacao}
          loadFotosAcomodacao={loadFotosAcomodacao}
          setOpenModalNew={setOpenModalNew}
        />
      </Modal>

      <Modal
        open={openModalEdit}
        onClose={() => {
          setOpenModalEdit(false);
        }}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
      >
        <EditFoto
          data={fotoEdit}
          loadFotosAcomodacao={loadFotosAcomodacao}
          setOpenModalEdit={setOpenModalEdit}
        />
      </Modal>
    </>
  );
}
